import { ORANGE, VERT, BRUN, ROUGE_TEXTE, STATUT_PIECE, dateFr, teinte } from './dossierUi'

/**
 * Une piece du dossier (prototype v7.5, bloc 3) : a fournir, en verification,
 * a refaire, expiree, validee — et l'action qui va avec. `p` = piece telle que
 * l'API la renvoie (statut deja derive : l'expiration est calculee au serveur).
 */
function CartePiece({ p, onDeposer }) {
  const st = STATUT_PIECE[p.statut] || STATUT_PIECE.MANQUANTE
  const btnPlein = 'mt-[11px] w-full rounded-[13px] text-[13px] font-extrabold'
  const lienDiscret = 'mt-2 text-[11.5px] font-bold'
  return (
    <div className="glass-surface rounded-[18px]" style={{ padding: '14px 15px' }}>
      <div className="flex items-center gap-3">
        <span className="w-10 h-10 rounded-[13px] flex-shrink-0 flex items-center justify-center text-[19px]"
          style={{ background: teinte(st.c, 0.1), border: `1px solid ${teinte(st.c, 0.25)}` }}>
          {p.emoji}
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-[13.5px] font-bold" style={{ color: VERT }}>
            {p.libelle}
            {p.optionnel && <span className="text-[10.5px] font-bold" style={{ color: 'rgba(7,62,61,0.45)' }}> · facultatif</span>}
          </p>
          <p className="text-[11px]" style={{ color: 'rgba(7,62,61,0.5)' }}>{p.preuve}</p>
        </div>
        <span className="text-[10.5px] font-extrabold rounded-full flex-shrink-0"
          style={{ color: st.c, background: teinte(st.c, 0.1), padding: '5px 10px' }}>
          {st.e} {st.l}
        </span>
      </div>

      {p.statut === 'MANQUANTE' && (
        <button onClick={onDeposer} className={btnPlein} style={{ padding: '11px 0', background: ORANGE, color: VERT }}>📷 Ajouter ›</button>
      )}

      {p.statut === 'EN_COURS' && (
        <>
          <p className="mt-2.5 text-[11.5px] leading-relaxed rounded-[11px]"
            style={{ color: 'rgba(7,62,61,0.55)', background: teinte(ORANGE, 0.08), padding: '10px 12px' }}>
            📎 {p.documentNom} reçu{p.dateValidite ? ` · valable jusqu'au ${dateFr(p.dateValidite)}` : ''} — vérification sous 48-72h.
          </p>
          <button onClick={onDeposer} className={lienDiscret} style={{ color: 'rgba(7,62,61,0.5)' }}>Remplacer le document ›</button>
        </>
      )}

      {(p.statut === 'REFUSEE' || p.statut === 'EXPIREE') && (
        <>
          <p className="mt-2.5 text-[11.5px] leading-relaxed rounded-[11px]"
            style={{ color: ROUGE_TEXTE, background: 'rgba(217,83,79,0.08)', padding: '10px 12px' }}>
            {p.statut === 'EXPIREE' ? `Votre document a expiré le ${dateFr(p.dateValidite)}.` : p.motifRefus || 'Document refusé.'}
          </p>
          <button onClick={onDeposer} className={btnPlein} style={{ padding: '11px 0', background: ORANGE, color: VERT }}>
            📷 Envoyer un nouveau document ›
          </button>
        </>
      )}

      {p.statut === 'VALIDEE' && (
        <>
          {p.dateValidite && (
            <p className="mt-2.5 text-[11.5px] leading-relaxed" style={{ color: p.bientot ? BRUN : 'rgba(7,62,61,0.55)' }}>
              {p.bientot
                ? `⚠️ Expire le ${dateFr(p.dateValidite)} — pensez à envoyer la nouvelle.`
                : `Valable jusqu'au ${dateFr(p.dateValidite)}.`}
            </p>
          )}
          <button onClick={onDeposer} className={lienDiscret} style={{ color: 'rgba(7,62,61,0.5)' }}>Mettre à jour le document ›</button>
        </>
      )}
    </div>
  )
}

export default CartePiece
